/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

// import { FeedbackHelpful } from "@simplicitycms/simplicity-forms";
import { FormProvider } from "@simplicitycms/simplicity-forms";
import { FeedbackHelpful } from "./feedback-helpful";
import { useSimpliCity } from "cms/hooks/use-simplicity";
import { useFeatureFlag } from "cms/features/use-feature-flag";

const FeedbackForm = (props) => {
    const { webpage, model, settings } = useSimpliCity();
    const feature = useFeatureFlag("feature_was_helpful");
    const component = props?.component;
    const url = window.location.href;

    // disable form by webpage/model settings
    const enabled = webpage?.show_feedback_form;
    if (!enabled) {
        console.info("feedback was disabled by model.");
        return null;
    }

    // disable form by org settings
    const form_guid = settings?.feedback_form_guid;
    if (!feature) {
        console.info("feedback was disabled by feature flag.");
        return null;
    }

    return (
        <>
            <FormProvider>
                <FeedbackHelpful
                    webpage={webpage}
                    model={model}
                    component={component}
                    urls={url}
                    form_guid={form_guid}
                />
            </FormProvider>
        </>
    );
};

FeedbackForm.displayName = "FeedbackForm";
export { FeedbackForm };
